import { action } from "@ember/object"
import { inject as service } from "@ember/service"
import Component from "@glimmer/component"
import type { KbEntry } from "@shared/models/kb-entry"
import BelongTo from "cc-frontend/helpers/belong-to"
import FindDoc from "cc-frontend/helpers/find-doc"
import HasManyAltogether from "cc-frontend/helpers/has-many-altogether"
import prepareKbHappyFaceClicked from "cc-frontend/lib/actions/app-state/KB_HAPPY_FACE_CLICKED"
import prepareKbSadFaceClicked from "cc-frontend/lib/actions/app-state/KB_SAD_FACE_CLICKED"
import type Dispatcher from "cc-frontend/services/dispatcher"
import { use } from "ember-could-get-used-to-this"
import { tracked } from "tracked-built-ins"

interface Signature {
  Element: HTMLDivElement
  Args: {
    entry: KbEntry
    chapter: KbEntry
  }
}

export default class KbEntryArticle extends Component<Signature> {
  @service declare dispatcher: Dispatcher

  @use article = new BelongTo(() => [this.args.entry, "child"])
  @use ancestors = new HasManyAltogether<KbEntry>(() => [this.args.entry, "ancestors", "kb-entry"])
  @use prismicDoc = new FindDoc(() => ["prismic-doc", this.article.content?.attributes?.prismicId])

  @tracked happyFaceClicked = false
  @tracked sadFaceClicked = false

  @action happyFace() {
    if (this.happyFaceClicked === true) return
    if (this.article.content === null) return
    this.happyFaceClicked = true

    //after
    this.dispatcher.dispatchPreparedAction(
      prepareKbHappyFaceClicked({
        article: this.article.content,
      })
    )
  }

  @action sadFace() {
    if (this.sadFaceClicked === true) return
    if (this.article.content === null) return
    this.sadFaceClicked = true

    this.dispatcher.dispatchPreparedAction(
      prepareKbSadFaceClicked({ article: this.article.content })
    )
    if (window && window.Intercom) {
      window.Intercom(
        "showNewMessage",
        `The article "${this.article.content?.attributes?.title}" didn't answer my question. I want to know:`
      )
    }
  }
}

declare module "@glint/environment-ember-loose/registry" {
  export default interface Registry {
    "Kb::Entry::Article": typeof KbEntryArticle
  }
}
